import { combineReducers } from "redux-immutable";

import { makeCrudStateReducer } from "seneca-common/utils/apiStates";

import UserMeta from "../../models/meta";
import {
  userInfoCrudStateConfig,
  passwordResetCrudStateConfig,
  userPreferenceCrudStateConfig
} from "../../consts";

export default combineReducers(
  {
    passwordReset: makeCrudStateReducer(passwordResetCrudStateConfig),
    userInfo: makeCrudStateReducer(userInfoCrudStateConfig),
    preferences: makeCrudStateReducer(userPreferenceCrudStateConfig)
  },
  () => new UserMeta() as any
);
